import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "hover:brightness-75 ease-in duration-100 rounded-md min-w-[13rem] bg-black relative" }
const _hoisted_2 = { class: "justify-center items-center flex h-7 rounded-md px-2 py-1" }
const _hoisted_3 = { class: "text-center text-ellipsis whitespace-nowrap overflow-hidden text-white" }
const _hoisted_4 = {
  key: 0,
  class: "rounded-full p-1 bg-black text-yellow-400 w-6 h-6 absolute right-1 top-1"
}

import { ref } from 'vue';
import { StarFilled } from '@ant-design/icons-vue';
import { Comic } from '@/model/comic';
import ImageLoading from '@/components/shared/ImageLoading.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'ComicCard',
  props: {
    comic: {}
  },
  setup(__props: any) {


const isLoading = ref(true);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ImageLoading, {
      src: _ctx.comic.imageURL,
      "img-class": "min-w-[13rem] min-h-[13rem] w-full aspect-square shadow-md",
      "loading-class": "min-w-[13rem] min-h-[13rem] w-full aspect-square shadow-md flex items-start",
      onLoad: _cache[0] || (_cache[0] = () => (isLoading.value = false))
    }, null, 8, ["src"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.comic.title), 1)
    ]),
    (_ctx.comic.isFavorite && !isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_unref(StarFilled))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})